import { Container, Text } from 'pixi.js';
import { BaseWidgetRenderer } from 'ff/debrief/components/hud/widgets/BaseWidgetRenderer';
import { CurrentPoint } from 'ff/debrief/models';
import { HudContext } from 'ff/debrief/components/hud/HudContext';
import { HudPositionTranslator } from 'ff/debrief/components/hud/utils';

export class LatLonRenderer extends BaseWidgetRenderer {
    static readonly requiredProperties = ['latitude', 'longitude'] as const;
    static readonly optionalProperties = [] as const;

    private latitudeText: Text;
    private longitudeText: Text;

    async populatePixiContainer(
        pixiContainer: Container,
        hudContext: HudContext,
        positionTranslator: HudPositionTranslator
    ): Promise<void> {
        // Use global configuration for visual properties
        const textStyle = {
            fontFamily: hudContext.globalConfig.fontFamily,
            fontSize: hudContext.globalConfig.baseFontSize,
            fill: hudContext.globalConfig.primaryLineColor,
        };

        this.latitudeText = new Text({
            text: 'Lat: --',
            style: textStyle,
        });
        this.longitudeText = new Text({
            text: 'Lon: --',
            style: textStyle,
        });

        const xPadding = 10;
        const yPadding = 10;
        // Position relative to container (container is already positioned by BaseWidgetRenderer)
        this.latitudeText.position.set(xPadding, yPadding);
        this.longitudeText.position.set(
            xPadding,
            yPadding + positionTranslator.y(0.1)
        );

        pixiContainer.addChild(this.latitudeText);
        pixiContainer.addChild(this.longitudeText);
    }

    protected updateWidget(point: CurrentPoint): void {
        // No availability check needed - widget only exists if data available
        this.latitudeText.text = `Lat: ${point.latitude.toFixed(6)}`;
        this.longitudeText.text = `Lon: ${point.longitude.toFixed(6)}`;
    }

    cleanUp(): void {
        this.latitudeText?.destroy();
        this.longitudeText?.destroy();
    }
}
